import ShoppingCartTwoToneIcon from "@mui/icons-material/ShoppingCartTwoTone";
import {
  Badge,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Fab,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useSelector } from "store";
import { totalQuantitySelector } from "store/slices/cart";
import { inIframe } from "utils/iframe";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 0,
    top: 3,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));

const FloatingCart = () => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const totalQuantity = useSelector(totalQuantitySelector);
  const navigate = useNavigate();
  const [isCheckoutModal, setIsCheckoutModal] = useState(false);

  const handleRedirection = () => {
    if (inIframe()) {
      setIsCheckoutModal(true);
    } else {
      navigate("/checkout", { replace: true });
    }
  };

  const redirect = () => {
    setIsCheckoutModal(false);
    window.open(
      process.env.REACT_APP_PUBLIC_URL + "/checkout",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const notRedirect = () => {
    setIsCheckoutModal(false);
  };

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={isCheckoutModal}
        onClose={notRedirect}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <FormattedMessage id="checkout.ask_for_redirection" />
        </DialogTitle>
        <DialogActions>
          <Button autoFocus onClick={notRedirect}>
            <FormattedMessage id="general.no" />
          </Button>
          <Button onClick={redirect} autoFocus>
            <FormattedMessage id="general.yes" />
          </Button>
        </DialogActions>
      </Dialog>
      <Fab
        component={Button}
        onClick={handleRedirection}
        size="large"
        sx={{
          top: "50%",
          position: "fixed",
          right: 0,
          zIndex: theme.zIndex.speedDial,
          boxShadow: theme.customShadows.warning,
          bgcolor: "warning.main",
          color: "warning.light",
          borderRadius: "8px",
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          "&:hover": {
            bgcolor: "warning.dark",
            color: "warning.light",
          },
        }}
      >
        <StyledBadge showZero badgeContent={totalQuantity} color="error">
          <ShoppingCartTwoToneIcon sx={{ color: "grey.800" }} />
        </StyledBadge>
      </Fab>
    </>
  );
};

export default FloatingCart;
